import { APIClient } from "../helpers/api_helper";
import { ApiResponse } from "../types/api";
import { User } from "./userService";

const api = new APIClient();

const RESOURCE = "/users/me";

export interface UpdateProfilePayload {
  name: string;
  email: string;
  locale: string;
  password?: string;
  password_confirmation?: string;
  current_password?: string;
}

export const getProfile = (): Promise<ApiResponse<User>> =>
  api.get<ApiResponse<User>>(RESOURCE);

export const updateProfile = (
  payload: UpdateProfilePayload
): Promise<ApiResponse<User>> =>
  api.update<ApiResponse<User>>(RESOURCE, payload);
